// @flow

import {
  ADVANCED_SECURITY_CUSTOM_DISCOUNTS_JSON_BACKEND_NAME,
  ADVANCED_SECURITY_TIERS_BACKEND_NAME,
} from '../../constants';

// Formik path to the tiers array, e.g. ['advanced_security_custom_discounts_json', 'tiers'].
// Read the tiers with formik's getIn(values, ADVANCED_SECURITY_TIERS_PATH).
export const ADVANCED_SECURITY_TIERS_PATH = [
  ADVANCED_SECURITY_CUSTOM_DISCOUNTS_JSON_BACKEND_NAME,
  ADVANCED_SECURITY_TIERS_BACKEND_NAME,
];

export const ADVANCED_SECURITY_DEFAULT_USAGE_PERCENTAGE_VALUE = 10;

// Tier 3 end is conceptually Infinity — the input is non-editable and shows this placeholder.
export const ADVANCED_SECURITY_TIER_END_INFINITY_PLACEHOLDER = 'Infinity';

export const ADVANCED_SECURITY_DEFAULT_TIER_1_START_VALUE = 0;

// Default tier end boundaries (in $). Tier 3 end is Infinity and is not stored.
export const ADVANCED_SECURITY_DEFAULT_TIER_1_END_VALUE = 250000;
export const ADVANCED_SECURITY_DEFAULT_TIER_2_END_VALUE = 500000;
